import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Spacer = styled.div `
  height: ${theme.spacing.md};
`;
